import { memo } from 'react';

const Textarea = ({
	fieldName = '', label = '', labelClasses = 'text-[0.875rem]', textareaValue = '', placeholder = '', handleChange = null, classes = '', showLabel = false, disabled = false, rows = 4, autofocus = false, backgroundColor = 'bg-oly-gray-lightestAlpha45', register, error = false,
}) => (
	<div className={`w-full ${classes}`}>
		<span>
			<label htmlFor={fieldName} className={`${showLabel ? `block mx-1 ${labelClasses} ${!error ? 'text-oly-gray-darkest' : 'text-oly-red-default'}` : 'sr-only'}`}>
				{label}
			</label>
			<div className="relative">
				<textarea
					id={fieldName}
					name={fieldName}
					rows={rows}
					className={`${showLabel ? 'mt-1 text-[0.875rem]' : 'text-[1.0625rem]'} resize-none block w-full py-2 px-3 transition duration-150 ease-in-out font-primary ${disabled ? 'bg-gray-200' : backgroundColor} text-oly-gray-darkest placeholder-oly-gray-default focus:outline-none focus-visible:ring-oly-blue-dark focus-visible:ring-2`}
					placeholder={placeholder}
					autoComplete="off"
					autoCorrect="off"
					onChange={(e) => handleChange(e.target.value || '')}
					defaultValue={textareaValue}
					disabled={disabled}
					autoFocus={autofocus} // eslint-disable-line jsx-a11y/no-autofocus
					{...register}
				/>
			</div>
		</span>
	</div>
);

export default memo(Textarea);
